import { combineReducers } from '@reduxjs/toolkit'

import applicationLogsReducer from './ApplicationLogs/slice'

const logsReducer = combineReducers({
  applicationLogsReducer
})

export default logsReducer
